var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.5 18a1 1 0 01-1 1h-11l-4 4v-4h-6a1 1 0 01-1-1V4a1 1 0 011-1h21a1 1 0 011 1v14z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIzLjUgMThDMjMuNSAxOC41NTIzIDIzLjA1MjMgMTkgMjIuNSAxOUgxMS41TDcuNSAyM1YxOUgxLjVDMC45NDc3MTUgMTkgMC41IDE4LjU1MjMgMC41IDE4VjRDMC41IDMuNDQ3NzIgMC45NDc3MTUgMyAxLjUgM0gyMi41QzIzLjA1MjMgMyAyMy41IDMuNDQ3NzIgMjMuNSA0VjE4WiIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgChat as ReactComponent };